import React, { useEffect, useState } from 'react';
import { WS_STATUS } from 'constants/wsStatus';

const NetworkStatusIndicator = ({ status }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Show indicator when offline or reconnecting
    if (status === WS_STATUS.OFFLINE || status === WS_STATUS.RECONNECTING) {
      setShow(true);
    }
    // Hide indicator when connected
    else if (status === WS_STATUS.CONNECTED) {
      const timer = setTimeout(() => {
        setShow(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  if (!show) return null;

  const getStatusConfig = () => {
    switch (status) {
      case WS_STATUS.OFFLINE:
        return {
          text: 'Connection lost',
          color: '#ef4444',
          bgColor: '#fef2f2',
        };
      case WS_STATUS.RECONNECTING:
        return {
          text: 'Reconnecting',
          color: '#f59e0b',
          bgColor: '#fffbeb',
        };
      case WS_STATUS.CONNECTED:
        return {
          text: 'Connected',
          color: '#10b981',
          bgColor: '#f0fdf4',
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  const barStyle = {
    position: 'fixed',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 9999,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 20px',
    background: config.bgColor,
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    color: config.color,
    fontSize: '13px',
    fontWeight: 500,
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    animation: 'slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  };

  const dotStyle = {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: config.color,
    animation: status === WS_STATUS.RECONNECTING ? 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' : 'none',
  };

  return (
    <>
      <style>
        {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateX(-50%) translateY(-100%);
            }
            to {
              opacity: 1;
              transform: translateX(-50%) translateY(0);
            }
          }
          
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.4;
            }
          }
        `}
      </style>
      <div style={barStyle}>
        <span style={dotStyle}></span>
        <span>{config.text}</span>
      </div>
    </>
  );
};

export default NetworkStatusIndicator;
